// Default Sorting Values
var boostAI_DefaultSortingValue = {
    sorting: "Sorting",
    sorting_best_selling: "Best Selling",
    sorting_featured: "Featured",
    sorting_heading: "Sorting",
    sorting_manual: "Manual",
    sorting_relevance: "Relevance",
    sorting_created_ascending: "Created Ascending",
    sorting_created_descending: "Created Descending",
    sorting_date_ascending: "Date Ascending",
    sorting_date_descending: "Date Descending",
    sorting_published_descending: "Published Descending",
    sorting_published_ascending: "Published Ascending",
    sorting_price_ascending: "Price Ascending",
    sorting_price_descending: "Price Descending",
    sorting_sale_ascending: "% Off",
    sorting_sale_descending: "% Off, Low to High",
    sorting_title_ascending: "Title Ascending",
    sorting_title_descending: "Title Descending"
};

// Apply default sorting values if translation is missing
try {
    const applyDefaultLabels = (config) => {
        if (typeof config !== 'undefined' && config.hasOwnProperty('label')) {
            for (const key in config.label) {
                if (config.label.hasOwnProperty(key) && typeof config.label[key] === 'string') {
                    const value = config.label[key].toLowerCase();
                    if (value.includes('translation missing') && boostAI_DefaultSortingValue[key]) {
                        config.label[key] = boostAI_DefaultSortingValue[key];
                    }
                }
            }
        }
    };

    applyDefaultLabels(boostPFSThemeConfig);
    applyDefaultLabels(bcSfFilterConfig);

} catch (error) {
    console.log('Patch defaultSortingValue error:', error);
}

// Initialize BoostPFS
const initializeBoostPFS = () => {
    var boostPFS = new BoostPFS();
    boostPFS.init();
    
    if (typeof boostPFSConfig !== 'undefined' 
        && typeof boostPFSConfig.general !== 'undefined' 
        && boostPFSConfig.general.isInitFilter) {
        boostPFS.initFilter();
    }

    BoostPFS.jQ(window).on('load', () => {
        boostPFS.initSearchBox();
        false && boostPFS.initAnalytics();
    });
};
// Debounce function to prevent rapid firing
function debounce(func, delay) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}

// Reattach video listeners after filter or pagination changes
BoostPFS.jQ(window).on('filterApplied filterRemoved', debounce(function() {
    attachVideoListeners(); // Attach video listeners after filters are applied or removed
}, 200));

// Ensure listeners are attached after DOM is ready and BoostPFS fully loads
document.addEventListener('DOMContentLoaded', () => {
    initializeBoostPFS();

    // Ensure BoostPFS is ready and listeners are attached correctly
    BoostPFS.jQ(window).on('load', () => {
        attachVideoListeners(); // Attach listeners after BoostPFS load
        toggleDescriptionOnClick();
        
    });
});


// Attach video event listeners only if not already attached
function attachVideoListeners() {
    document.querySelectorAll('.video-container').forEach(videoContainer => {
        const video = videoContainer.querySelector('.video-container__video');
        const videoControls = videoContainer.querySelector('.video-container__controls');
        const fullscreenControl = videoContainer.querySelector('.control--fullscreen');
        const playControl = videoContainer.querySelector('.control--play');
        const volumeControl = videoContainer.querySelector('.control--volume__button');
        const progressBar = videoContainer.querySelector('.progress');
        const playButton = videoContainer.querySelector('.play-button');

        // Check if video and controls are present
        if (!video) {
            console.error('No video found in the container:', videoContainer);
            return;
        }

        if (!videoControls) {
            console.error('No controls found in the container:', videoContainer);
            return;
        }

        // Check if listener is already attached
        if (videoContainer.getAttribute('data-listener-attached')) {
            return;
        }

        videoContainer.setAttribute('data-listener-attached', 'true');
        video.controls = false; // Disable native controls to use custom ones

        // Set default muted state and volume control icon
        const setVolumeControlIcon = () => {
            if (volumeControl) {
                volumeControl.parentNode.classList.add('muted');
                volumeControl.classList.add('fa-volume-off');
                volumeControl.classList.remove('fa-volume-up');
            }
        };

        // Set initial volume
        video.volume = 0;
        setVolumeControlIcon();

        // Update play button visibility
        const updatePlayButton = () => {
            if (video.paused) {
                if (playButton) playButton.style.display = 'block';
                if (playControl) playControl.classList.add('paused');
            } else {
                if (playButton) playButton.style.display = 'none';
                if (playControl) playControl.classList.remove('paused');
            }
        };

        // Play/Pause button (custom controls)
        if (playControl) {
            playControl.addEventListener('click', () => {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
                updatePlayButton();
            });
        }

        // Play button (with touchstart for iOS)
        if (playButton) {
            const handlePlayButton = (event) => {
                event.preventDefault(); // Prevent double click issues
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
                updatePlayButton();
            };

            playButton.addEventListener('click', handlePlayButton);
            playButton.addEventListener('touchstart', handlePlayButton); // Added for iOS compatibility
        }

        // Volume control (custom controls)
        if (volumeControl) {
            volumeControl.addEventListener('click', () => {
                const isMuted = volumeControl.parentNode.classList.toggle('muted');
                if (isMuted) {
                    video.muted = true;
                    video.volume = 0;
                    volumeControl.classList.add('fa-volume-off');
                    volumeControl.classList.remove('fa-volume-up');
                } else {
                    video.muted = false;
                    video.volume = 1;
                    volumeControl.classList.add('fa-volume-up');
                    volumeControl.classList.remove('fa-volume-off');
                }
            });
        }

        // Progress bar (custom controls)
        if (progressBar) {
            video.addEventListener('timeupdate', () => {
                const progress = (100 / video.duration) * video.currentTime;
                videoContainer.querySelector('.progress__current').style.width = `${progress}%`;
            });

            progressBar.addEventListener('click', (e) => {
                const goToTime = (e.offsetX / progressBar.offsetWidth) * video.duration;
                video.currentTime = goToTime;
            });
        }

         // Fullscreen control (custom controls)
         if (fullscreenControl) {
            fullscreenControl.addEventListener('click', () => {
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        
                if (isIOS && video.webkitEnterFullScreen) {
                    // Only allow fullscreen on the video element for iOS
                    video.webkitEnterFullScreen();
                } else if (document.fullscreenElement !== videoContainer) {
                    videoContainer.requestFullscreen().catch(err => console.error('Failed to enter fullscreen:', err));
                } else {
                    document.exitFullscreen().catch(err => console.error('Failed to exit fullscreen:', err));
                }
            });
        }
        

        const handleFullscreenChange = () => {
            if (document.fullscreenElement === videoContainer) {
                videoContainer.classList.add('fullscreen');
            } else {
                videoContainer.classList.remove('fullscreen');
            }
        };
        
        const handleWebkitFullscreen = () => {
            videoContainer.classList.add('fullscreen');
            video.addEventListener('webkitendfullscreen', () => {
                videoContainer.classList.remove('fullscreen');
            }, { once: true });
        };
        
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        
        // Add event listener for iOS fullscreen mode
        if (video.webkitEnterFullScreen) {
            video.addEventListener('webkitbeginfullscreen', handleWebkitFullscreen);
        }

        // Pause video on click if it's playing, and play if paused (with touch support)
        const handleVideoToggle = (event) => {
            event.preventDefault(); // Prevent double action
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
            updatePlayButton();
        };

        video.addEventListener('click', handleVideoToggle);
        video.addEventListener('touchstart', handleVideoToggle); // Added for iOS to handle touch events properly

        // Reset video when it ends
        video.addEventListener('ended', () => {
            video.currentTime = 0;
            updatePlayButton();
        });

        // Initialize button state
        updatePlayButton();
    });
}

// Call the function to attach event listeners after BoostPFS is initialized
attachVideoListeners();


// Event listener for custom filter button
document.addEventListener('DOMContentLoaded', () => {
    toggleDescriptionOnClick();
    const filterButton = document.querySelector('.boost-pfs-filter-custom-filter-button');
    
    if (filterButton) {
        filterButton.addEventListener('click', () => {
            initializeBoostPFS();
            attachVideoListeners(); // Attach after clicking the custom filter button
            toggleDescriptionOnClick();
        });
    }
});

// Function to toggle description visibility
function toggleDescriptionOnClick() {
    const lifestyleBlocks = document.querySelectorAll('.inline-lifestyle-block');

    lifestyleBlocks.forEach(block => {
        const learnMoreBtn = block.querySelector('.learn-more-btn');
        const description = block.querySelector('.lifestyle-desc');
        const playButton = block.querySelector('.play-button'); // Select play button inside block

        // Ensure event listeners are not re-attached
        if (learnMoreBtn && description && !learnMoreBtn.hasAttribute('data-listener-attached')) {
            learnMoreBtn.setAttribute('data-listener-attached', 'true');
            learnMoreBtn.setAttribute('data-expanded', 'false'); // Initialize state
            description.classList.add('hidden'); // Hide the description initially

            // Toggle description visibility when "Learn more" button is clicked
            learnMoreBtn.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent default link action
                event.stopPropagation(); // Prevent click event from propagating up to the document
                const isExpanded = learnMoreBtn.getAttribute('data-expanded') === 'true';
                description.classList.toggle('hidden', isExpanded);
                learnMoreBtn.innerHTML = isExpanded ? 'Learn more <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#ffffff"><path d="M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Z"/></svg>' : 'Show less <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#ffffff"><path d="m339-288 141-141 141 141 51-51-141-141 141-141-51-51-141 141-141-141-51 51 141 141-141 141 51 51ZM480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Z"/></svg>';
                learnMoreBtn.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
            });

            // Toggle description when clicking on the description itself
            description.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent default link action
                const isExpanded = learnMoreBtn.getAttribute('data-expanded') === 'true';
                description.classList.toggle('hidden', isExpanded);
                learnMoreBtn.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
                learnMoreBtn.innerHTML = isExpanded ? 'Learn more <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#ffffff"><path d="M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Z"/></svg>' : 'Show less <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#ffffff"><path d="m339-288 141-141 141 141 51-51-141-141 141-141-51-51-141 141-141-141-51 51 141 141-141 141 51 51ZM480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Z"/></svg>';
            });

            // Toggle visibility when clicking on the play button
            if (playButton) {
                playButton.addEventListener('click', (event) => {
                    // Hide all descriptions and reset buttons when play button is clicked
                    lifestyleBlocks.forEach(b => {
                        const btn = b.querySelector('.learn-more-btn');
                        const desc = b.querySelector('.lifestyle-desc');
                        if (btn && desc && btn.getAttribute('data-expanded') === 'true') {
                            desc.classList.add('hidden');
                            btn.setAttribute('data-expanded', 'false');
                            btn.innerHTML = 'Learn more <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#ffffff"><path d="M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Z"/></svg>';
                        }
                    });
                });
            }
        }
    });

    // Event listener to close only expanded descriptions when clicking outside any lifestyle block
    document.addEventListener('click', (event) => {
        lifestyleBlocks.forEach(block => {
      
            const learnMoreBtn = block.querySelector('.learn-more-btn');
            const description = block.querySelector('.lifestyle-desc');

            // Check if click happened outside the block and if the description is expanded
            if (!block.contains(event.target) && learnMoreBtn && learnMoreBtn.getAttribute('data-expanded') === 'true') {
                description.classList.add('hidden');
                learnMoreBtn.setAttribute('data-expanded', 'false');
                learnMoreBtn.innerHTML = 'Learn more <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#ffffff"><path d="M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Z"/></svg>';
            }
        });
    });
}

// Initialize the toggle function
toggleDescriptionOnClick();

// MutationObserver for .boost-collection__content changes
const boostCollectionContent = document.querySelector('.boost-collection__content');

if (boostCollectionContent) {
    const observer = new MutationObserver(debounce((mutationsList) => {
        let contentChanged = false;
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                contentChanged = true; // Only reattach if new nodes are added
                break;
            }
        }

        if (contentChanged) {
            document.body.removeAttribute('data-current-inline-block');
            attachVideoListeners(); // Reattach after content changes
            toggleDescriptionOnClick();
        }
    }, 300)); // Use debounce to throttle rapid changes

    observer.observe(boostCollectionContent, { childList: true, subtree: true }); // Watch for changes in children
}

function waitForElements(selectors, callback) {
    const observer = new MutationObserver((mutations, observer) => {
        const allElementsLoaded = selectors.every(selector => document.querySelector(selector));
        if (allElementsLoaded) {
            callback();
            observer.disconnect(); // Stop observing once all elements are found
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

function waitForElements(selectors, callback) {
    const observer = new MutationObserver((mutations, observer) => {
        const allElementsLoaded = selectors.every(selector => document.querySelector(selector));
        if (allElementsLoaded) {
            callback();
            observer.disconnect(); // Stop observing once all elements are found
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

